import React from 'react';
import './Dashboard.scss';
import Chart from 'chart.js/auto';
import {
  MotifIcon
} from "@ey-xd/motif-react";
import { infoIcon} from '../../../common/MotifIcons';
import {
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar, Line, getElementsAtEvent } from 'react-chartjs-2';
import {
  NWCChartOptions,
  RevenueGrowthChartOptions,
  CashConversionChartOptions,
} from './chartOptions';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { NO_DATA_FOUND } from '../../../common/contants/constants';


Chart.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ChartDataLabels,
  Title,
  Tooltip,
  Legend
);

export const Dashboard = ({ sectorData, isLoading }) => {

  const [selectedYear, setSelectedYear] = React.useState('');
  const [bgColor, setBgColor] = React.useState([]);
  const [borderColor, setBorderColor] = React.useState('');
  const [bgColor1, setBgColor1] = React.useState([])
  const [borderColor1, setBorderColor1] = React.useState('');

  const setColor = (color) => {
    let colorsArray = [];
    sectorData && sectorData.forEach((value, i) => {
      colorsArray[i] = color;
    })
    return colorsArray;
  }

  React.useEffect(() => {
    const index = sectorData?.length - 1;
    setSelectedYear(sectorData && sectorData[index]?.year || '');
    setBgColor(setColor('#188CE5'));
    setBgColor1(setColor('#EE8300'))
    setBorderColor('#188CE5');
    setBorderColor1('#EE8300');
  }, [sectorData])

  const NWCChartRef = React.useRef(null);
  const RevenueGrowthChartRef = React.useRef(null);

  const NWCChartData = {
    labels: sectorData?.map((item) => {
      return item.year;
    }),
    datasets: [
      {
        yAxisID: 'revenue',
        label: 'Revenue($M)',
        data: sectorData?.map((item) => {
          return parseFloat(item.opexpercrevenue/1000000).toFixed(2);
        }),
        type: 'line',
        backgroundColor: bgColor1,
        borderColor: borderColor1,
        fill: false,
      },
      {
        yAxisID: 'nwc',
        label: 'NWC as a % of Revenue',
        data: sectorData?.map((item) => {
          return parseFloat(item.nwcAsAPercentageOfRevenue).toFixed(2);
        }),
        type: 'bar',
        backgroundColor: bgColor,
        barPercentage: 0.5
      },
    ],
  };

  const RevenueGrowthChartData = {
    labels: sectorData?.map((item) => {

        return item.year;
    }),
    datasets: [
      {
        yAxisID: 'growth',
        label: 'Revenue Growth',
        data: sectorData?.map((item) => {
          return parseFloat(item.revenueGrowth).toFixed(2);
        }),
        type: 'line',
        backgroundColor: bgColor,
        borderColor: borderColor,
        fill: false,
      },
    ],
  };

  const CashConversionChartData = {
    labels: sectorData?.filter((item) => {
      return item.year === selectedYear;
    })[0]?.monthlyInsights.map((x) => {
      return x.month
    }),
    datasets: [
      {

        label: 'DIO',
        data: sectorData?.filter((item) => {
          return item.year === selectedYear;
        })[0]?.monthlyInsights.map((x) => {
          return x.avgDio
        }),
        type: 'line',
        backgroundColor: '#EE8300',
        borderColor: '#EE8300',
        fill: false,
      },

      {
        label: 'DPO',
        data: sectorData?.filter((item) => {
          return item.year === selectedYear;
        })[0]?.monthlyInsights.map((x) => {
          return x.avgDpo
        }),
        type: 'line',
        backgroundColor: '#00008B',
        borderColor: '#00008B',
        fill: false,
      },
      {

        label: 'DSO',
        data: sectorData?.filter((item) => {
          return item.year === selectedYear;
        })[0]?.monthlyInsights.map((x) => {
          return x.avgDso
        }),
        type: 'line',
        backgroundColor: '#188CE5',
        borderColor: '#188CE5',
        fill: false,
      }
    ]
  };

  const handleChartClick = (element, data) => {
    if (!element.length) return;
    const { index } = element[0];
    const newBgColor1 = bgColor.map((value, i) => {

      return i !== index ? 'rgb(238,131,0, 0.4)' : '#EE8300';
    });

    const newBgColor = bgColor.map((value, i) => {
      return i === index ? '#188CE5' : 'rgb(24,140,229, 0.4)';
    });

    setBgColor(newBgColor);
    setBorderColor('rgb(24,140,229, 0.4)');
    setBgColor1(newBgColor1);
    setBorderColor1('rgb(238,131,0, 0.4)');
    setSelectedYear(data.labels[index]);
  };

  const handleNWCChartClick = (event, data) => {
    const { current: chart } = NWCChartRef;
    if (!chart) {
      return;
    }
    handleChartClick(getElementsAtEvent(chart, event), data);
  };

  const handleRevenueGrowthChartClick = (event, data) => {
    const { current: chart } = RevenueGrowthChartRef;
    if (!chart) {
      return;
    }
    handleChartClick(getElementsAtEvent(chart, event), data);
  };

  const getYear = () => {
    const year = sectorData?.filter((item) => {
      return item.year === selectedYear;
    })[0];
    return year;
  }

  const trimmedyear = (year) => {
   return  year.toString().slice(-2);
  }

  return (
    <React.Fragment>
         {

        <div className='dashboard-container'>
          <div className='dashboard-top'>
            <div className='dashboard-top-left'>
              <div className='dashboard-gross'>
                {`FY ${trimmedyear(selectedYear)} Gross Margin`}
                <div className='gross-wrapper'>
                  <span>{
                      isLoading ?
                        <div className='fallback-msg'>Loading</div> :   getYear()?.grossMargin ?
                        parseFloat(getYear().grossMargin).toFixed(2) + '%' :
                         <div className='fallback-msg'>{NO_DATA_FOUND}</div>
                  }</span>
                  <img
                    src={require('../../../../src/common/images/stats-up-square.png')}
                    alt='stats'
                    className='gross-icon'
                  />
                </div>
              </div>
              <div className='dashboard-gross'>
                {`FY ${trimmedyear(selectedYear)} EBITDA Margin`}
                <div className='gross-wrapper'>
                  <span>{
                      isLoading ?
                        <div className='fallback-msg'>Loading</div> :  getYear()?.ebitdaMargin ?
                        parseFloat(getYear()?.ebitdaMargin).toFixed(2) + '%' :
                        <div className='fallback-msg'>{NO_DATA_FOUND}</div>
                  }
                  </span>
                  <img
                    className='gross-icon'
                    src={require('../../../../src/common/images/stats-report.png')}
                    alt='stats'
                  />
                  
                </div>
              </div>
            </div>
            <div className='dashboard-top-right'>
              <div className='dashboard-nc'>
                <div className='chart-heading'>
                  Net Working Capital as a Percentage of Revenue
                </div>
                {
                  isLoading ? <div className='fallback-msg'>Loading</div> : <Bar ref={NWCChartRef} data={NWCChartData} options={NWCChartOptions} onClick={(element) => handleNWCChartClick(element, NWCChartData)} />
                }
              </div>
              <div className='dashboard-rt'>
                <div className='chart-heading'>Revenue Growth Over Time</div>
                {
                  isLoading ? <div className='fallback-msg'>Loading</div> : <Line ref={RevenueGrowthChartRef} data={RevenueGrowthChartData} options={RevenueGrowthChartOptions} onClick={(element) => handleRevenueGrowthChartClick(element, RevenueGrowthChartData)} />
                }
              </div>
            </div>
          </div>
          <div className='dashboard-bottom'>
            <div className='dashboard-bottom-left'>
              <div className='dashboard-dso'>
                <div className='dashboard-ds'>
                  <img
                    className='gross-icon gross-small-icon'
                    src={require('../../../../src/common/images/graph-up.png')}
                    alt='graph-up'
                  />
                  {`FY ${trimmedyear(selectedYear)} DSO`}
                </div>
                <span >{
                    isLoading ?
                      <div className='fallback-msg'>Loading</div> :  getYear()?.averageDso ?
                      parseFloat(getYear()?.averageDso).toFixed(2) :
                      <div className='fallback-msg'>{NO_DATA_FOUND}</div>
                }</span>
              </div>

              <div className='dashboard-dpo'>
                <div className='dashboard-ds'>
                  <img
                    className='gross-icon gross-small-icon'
                    src={require('../../../../src/common/images/coin.png')}
                    alt='coin'
                  />
                  {`FY ${trimmedyear(selectedYear)} DPO`}
                </div>
                <span>{
                    isLoading ?
                      <div className='fallback-msg'>Loading</div> : getYear()?.averageDpo ?
                      parseFloat(getYear()?.averageDpo).toFixed(2) :
                      <div className='fallback-msg'>{NO_DATA_FOUND}</div>
                }</span>
              </div>
              <div className='dashboard-dio'>
                <div className='dashboard-ds'>
                  <img
                    className='gross-icon gross-small-icon'
                    src={require('../../../../src/common/images/report-columns.png')}
                    alt='report-columns'
                  />
                  {`FY ${trimmedyear(selectedYear)} DIO`}
                </div>
                <span>{
                    isLoading ?
                      <div className='fallback-msg'>Loading</div> :  getYear()?.averageDio ? parseFloat(getYear()?.averageDio).toFixed(2) : <div className='fallback-msg'>{NO_DATA_FOUND}</div>
                }</span>
              </div>
            </div>
            <div className='dashboard-bottom-right'>
              <div className='dashboard-cc'>
                <div className='chart-heading'> {`FY ${trimmedyear(selectedYear)}`} Cash Conversion Cycle Over Time</div>
                {
                  isLoading ? <div className='fallback-msg'>Loading</div> : <Line
                    className={'chart-container '}
                    data={CashConversionChartData}
                    options={CashConversionChartOptions}
                  />
                }
              </div>
            </div>
           
          </div>
          <div className='warning-msg'> <MotifIcon src={infoIcon} /><div className='text'> Outputs are generated by AI. AI can generate incorrect predictions. Review of all generated content is strongly advised.</div></div>
        </div>
      }

    </React.Fragment>
  );
};




